<!-- eslint-disable no-unused-vars -->
<!--Designed & Developed by:
   Nirmal K (@cyberwizard1001)⁶
   Nitin Ravi (@nitinravi)
   Ritwik M (@ritwik-m) &
   Nalinadevi K (@knaldev)
for the Ministry of Education (MOE) virtual-labs project, Govt. Of India -->

<script>
import OneClerkComponent from "@/components/OneClerkComponent.vue";
import OneClassComponent from "../components/OneDiagramComponent.vue";
import OneCustomerComponent from "../components/OneCustomerComponent.vue";
import OneReservationComponent from "../components/OneReservationComponent.vue";
import OnePersonComponent from "../components/OnePersonComponent.vue";
import OneVehicleComponent from "../components/OneVehicleComponent.vue";
import OneRentalSystemComponent from "@/components/OneRentalSystemComponent.vue";
import OneInstructionsComponent from "../components/OneInstructionsComponent.vue";
import OneTestDriverComponent from "@/components/OneTestDriverComponent.vue";

export default {
  components: {
    OneClerkComponent,
    OneClassComponent,
    OneCustomerComponent,
    OnePersonComponent,
    OneReservationComponent,
    OneVehicleComponent,
    OneRentalSystemComponent,
    OneInstructionsComponent,
    OneTestDriverComponent,
  },

  data() {
    return {
      componentSelect: "OneInstructionsComponent",
      oneTestDriveCompletion: false,
    };
  },
  methods: {
    instructionsReadCallback(value) {
      console.log(value);
      this.componentSelect = 'OneTestDriverComponent'
    },
    oneTestDriveCompletionCallback(value) {
      this.oneTestDriveCompletion = true
      this.componentSelect = 'OneClassComponent'
    }
  },
}
</script>

<template>
  <main class="app">
    <div class="buttons">
      <button @click="componentSelect = 'OneInstructionsComponent'"
              :style="componentSelect === 'OneInstructionsComponent' ? 'background-color: #55acee' : ''">1. Instructions
      </button>
      <button @click="componentSelect = 'OnePersonComponent'"
              :style="componentSelect === 'OnePersonComponent' ? 'background-color: #55acee' : ''">2. Person
      </button>
      <button @click="componentSelect = 'OneClerkComponent'"
              :style="componentSelect === 'OneClerkComponent' ? 'background-color: #55acee' : ''">3. Exec
      </button>
      <button @click="componentSelect = 'OneCustomerComponent'"
              :style="componentSelect === 'OneCustomerComponent' ? 'background-color: #55acee' : ''">4. Customer
      </button>
      <button @click="componentSelect = 'OneVehicleComponent'"
              :style="componentSelect === 'OneVehicleComponent' ? 'background-color: #55acee' : ''">5. Vehicle
      </button>
      <button @click="componentSelect = 'OneReservationComponent'"
              :style="componentSelect === 'OneReservationComponent' ? 'background-color: #55acee' : ''">6. Reservation
      </button>
      <button @click="componentSelect = 'OneRentalSystemComponent'"
              :style="componentSelect === 'OneRentalSystemComponent' ? 'background-color: #55acee' : ''">7. Rental System
      </button>
      <button @click="componentSelect = 'OneTestDriverComponent'"
              :style="componentSelect === 'OneTestDriverComponent' ? 'background-color: #55acee' : ''">8. Test Driver
      </button>
      <button @click="componentSelect = 'OneClassComponent'"
              :style="componentSelect === 'OneClassComponent' ? 'background-color: #55acee' : ''">9. Class Diagram
      </button>

    </div>

    <KeepAlive>
      <component
          v-bind:is="componentSelect"
          @instructions-read="instructionsReadCallback"
          @one-test-driver-completed="oneTestDriveCompletionCallback"
      />
    </KeepAlive>
  </main>
  <!--eslint-disable-next-line vue/no-multiple-template-root-->
  <footer v-show="oneTestDriveCompletion">
    <div id="buttons" class="relative">
      <button class="navitem" @click="$router.push('/screen-two')">Next</button>
    </div>
  </footer>
</template>

<style>
.app {
  background-color: #f9fafe;
  min-height: 1024px;
}

button {
  margin-top: 30px;
  border: none;
  padding: 20px;
  margin-left: 5px;
  background-color: #2c3e50;
  color: white;
  width: 500px;
}

button:first-of-type {
  margin-left: 30px;
}

.buttons {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  margin-top: 0;
}
</style>
 